import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {DataProcessContainer} from "../Model/dataProcess/dataprocesscontainer";
import {lastValueFrom} from "rxjs";
import {GoldenRecord} from "../Model/goldenRecord";

@Injectable()
export class GoldenRecordService {
  private readonly apiUrl = 'api/GoldenRecord';

  constructor(private http: HttpClient) {}

  public getGoldenRecord(customerId: string): Promise<GoldenRecord> {
    const url = `${this.apiUrl}/getGoldenRecord`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<GoldenRecord>(url, options));
  }
}
